import {gettext} from "@/utils/translate";

export const Permissions = {
    HPO__LIST_ACCESS: 'hpo__list_access',
    HPO__CREATE: 'hpo__create',
    HPO__MEMBER_TYPE_SWITCH: 'hpo__member_type_switch',
    DEVICE__MANAGE: 'device__manage',
}

export const PermissionsLabels = {
    'hpo__list_access': gettext('HPO - Access HPO list '),
    'hpo__create': gettext('HPO - Create new '),
    'hpo__member_type_switch': gettext('HPO - Switch member type'),
    'device__manage': gettext('Devices - Manage '),
}
